import { render, staticRenderFns } from "./WorkspaceBackupMenu.vue?vue&type=template&id=258cb6f8&"
import script from "./WorkspaceBackupMenu.vue?vue&type=script&lang=js&"
export * from "./WorkspaceBackupMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WorkspaceBackupMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/WorkspaceBackupMenu.vue
// module id = 2316
// module chunks = 1